<ap-section-header>
  <ap-section-header-grid
    [iconId]="'ap-basedata-icon'"
    [caption]="'Global__Fertilizer'"
    [filterPlaceholder]="'Global_Filter'"
    [filterTooltip]="'Global__Fertilizer'"
    [createText]="'Global__New'"
    (createDataset)="createNew()"
    [canCreate]="(ApPermissions.EDIT_FERTILIZER | getPermission | async)"
    (search)="searchIn($event)"
  ></ap-section-header-grid>
</ap-section-header>
<div class="ap-tabstrip-small">
  <kendo-tabstrip (tabSelect)="selectTab($event)" id="ressourcesTabStrip">
    <kendo-tabstrip-tab [selected]="true">
      <ng-template kendoTabTitle>
        <ap-responsive-text key="Settings__Lbl_Menu_Organicfertilizers" class="ap-tabstrip-header"></ap-responsive-text>
      </ng-template>
      <ng-template kendoTabContent>
        <ap-fertilizer-organic-overview></ap-fertilizer-organic-overview>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab>
      <ng-template kendoTabTitle>
        <ap-responsive-text key="Settings__Lbl_Menu_Inorganicfertilizers" class="ap-tabstrip-header"></ap-responsive-text>
      </ng-template>
      <ng-template kendoTabContent>
        <ap-fertilizer-inorganic-overview></ap-fertilizer-inorganic-overview>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>
